export default {"src":"/_next/static/media/effect-droplets.ab653e47.svg","height":488,"width":1077,"blurWidth":0,"blurHeight":0};